import { gql } from "@apollo/client";

export const GET_CURRENCY = gql`
  query getCurrencyDetails {
    currency {
      base_currency_code
      base_currency_symbol
      default_display_currency_code
      default_display_currency_symbol
      available_currency_codes
      __typename
    }
  }
`;
